// Extrai filename do header Content-Disposition (RFC 5987/6266)
export function getFilenameFromContentDisposition(header?: string | null): string | undefined {
  if (!header) return;
  // filename*=UTF-8''<urlencoded>
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (star?.[1]) {
    try { return decodeURIComponent(star[1]); } catch { /* ignore */ }
  }
  // filename="<quoted>" ou filename=sem aspas
  const plain = /filename\s*=\s*"(.*?)"/i.exec(header) ?? /filename\s*=\s*([^;]+)/i.exec(header);
  return plain?.[1]?.trim()?.replace(/["]/g, "");
}

// Salva um Blob no navegador com fallback simples
export function saveBlob(blob: Blob, filename: string) {
  // File System Access API (opcionalmente)
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download.bin";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function sanitizeFilename(name: string, def = "download.zip"): string {
  const cleaned = name
    .replace(/[/\\:*?"<>|]/g, "_")  // inválidos em SOs
    .replace(/\s+/g, " ")
    .replace(/\.\./g, ".")
    .trim();

  const safe = cleaned || def;
  return safe.toLowerCase().endsWith(".zip") ? safe : `${safe}.zip`;
}